// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "root-2aVJS";
var _4 = "payload-1v4-i";
var _5 = "icon-2qqZY";
var _6 = "text-HtlG7";
var _7 = "review-3AsXN";
var _8 = "buttons-2lR7V";
var _9 = "account-1iXut";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "root", _4 as "payload", _5 as "icon", _6 as "text", _7 as "review", _8 as "buttons", _9 as "account" }
export default { "__esModule": _1, "tabletMiddle": _2, "root": _3, "payload": _4, "icon": _5, "text": _6, "review": _7, "buttons": _8, "account": _9 }
